// @ts-nocheck

export type PropertyListWithOwner = typeof PropertyListWithOwner[keyof typeof PropertyListWithOwner];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyListWithOwner = {
  true: 'true',
  false: 'false',
} as const;
